import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { IkePageName } from '../../page/page';
import { Services } from '../../services';
import type { RouteParams } from '../../services/route.service';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { CSS, MDL } from './image.button.style';

export { CSS } from './image.button.style';

export interface ImageButtonCtx {
	type?: 'button' | 'a';
	className?: string;
	id?: string;
	disabled?: boolean;
	title?: T | string;
	titleAttrs?: any;
	href?: IkePageName;
	hrefParams?: RouteParams;
	flip?: boolean;
	onclick?: (a: MouseEvent) => void;
	testId?: string;
}

export function view(icon: MaterialIcon | MithrilVNode, ctx: ImageButtonCtx = {}) {
	const href = ctx.href ? Services.Route.getRouteURL(ctx.href, ctx.hrefParams) : undefined;
	const extraClassName = ctx.className != null ? ctx.className : '';
	const isMaterialIcon = typeof icon === 'string';
	const title = ctx.title != null ? Translate(ctx.title, ctx.titleAttrs) : '';

	return m(
		ctx.type || 'a',
		{
			className: `${MDL.container} ${CSS.container} ${extraClassName != null ? extraClassName : ''}`,
			id: ctx.id,
			'data-testid': ctx.testId,
			...(ctx.disabled && { disabled: ctx.disabled }),
			title,
			href,
			onclick: ctx.disabled ? undefined : ctx.onclick,
		},
		isMaterialIcon ? Icon.view(icon, { className: CSS.icon + ' ' + (ctx.flip ? CSS.flip : '') }) : icon
	);
}

export const ImageButton = { view, CSS };
